import { StackedBarchartModule } from '../stacked-bar-chart/stackedbarchart.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { GanttChartWidget } from './component/gantt-chart/gantt-chart.component';
import { StationGroupComponent } from './component/station-group/station-group.component';
import { TransportRowComponent } from './component/transport-row/transport-row.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { StructureNodeSelectionModule } from '../../../components/structure-node-selection/structure-node-selection.module';
import { GanttLegendComponent } from './component/gantt-legend/gantt-legend.component';
import { GanttLinesComponent } from './component/gantt-lines/gantt-lines.component';
import { GanttScaleComponent } from './component/gantt-scale/gantt-scale.component';
import { TransportItemComponent } from './component/transport-item/transport-item.component';

@NgModule({
  imports: [
    CommonModule,
    CommonUIModule,
    FormsModule,
    ReactiveFormsModule,
    StackedBarchartModule,
    CommonTranslationModule,
    CommonLayoutModule,
    StructureNodeSelectionModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule
  ],
  declarations: [
    GanttChartWidget,
    StationGroupComponent,
    TransportRowComponent,
    TransportItemComponent,
    GanttScaleComponent,
    GanttLinesComponent,
    GanttLegendComponent
  ]
})
export class GanttChartModule { }
